import { createAction, props } from '@ngrx/store';
import { LetterTemplate } from './letter-template.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records letter template'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records letter template success', 
    props<{ listData: LetterTemplate[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records letter template failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record letter template',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record letter template success', 
    props<{ singleData: LetterTemplate }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record letter template failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record letter template',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record letter template success'
);
export const addRecordFailure = createAction(
    '[Data] Add record letter template failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record letter template',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record letter template success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record letter template failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record letter template',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record letter template success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record letter template failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state letter template',
);